import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import SendBird from 'sendbird';
import ChatConnectList from './components/ChatConnectList';
import ChatConnectFooter from './components/ChatConnectFooter';
import ConnectContext from './components/context/connectContext';
import api from './components/context/api';

import './components/styles/chatconnectwrapper.scss';

const Connect = ({ ...props }) => {
  const { sb_id, sb_user, sb_token, language } = props;
  const [sendbirdData, setSendbirdData] = useState({
    sendbird: null,
    currentUser: null,
  });

  const [trans, setTrans] = useState(null);

  const _doPing = () => {
    api.get('chat/ping/', {
      headers: {
        'x-sendbird-id': sb_user,
        'x-sendbird-token': sb_token,
      },
    });
  };

  useEffect(() => {
    const sb = new SendBird({
      appId: sb_id,
    });

    let currentLanguage = '';
    if (language !== 'en') {
      currentLanguage = `/${language}`;
    }

    fetch(`${process.env.REACT_APP_PORTAL_URL}${currentLanguage}/chat/essentials/`)
      .then(response => response.json())
      .then(data => {
        setTrans(data);
      });

    sb.connect(sb_user, sb_token, user => {
      setSendbirdData({
        sendbird: sb,
        currentUser: user,
      });
    });

    _doPing();

    setInterval(_doPing, 60000);

    let disconnectTimeOut = null;

    const onFocus = () => {
      if (disconnectTimeOut !== null) {
        clearTimeout(disconnectTimeOut);
        disconnectTimeOut = null;
      }
      sb.connect(sb_user, sb_token, user => {
        setSendbirdData({
          sendbird: sb,
          currentUser: user,
        });
      });
    };

    const onBlur = () => {
      disconnectTimeOut = setTimeout(() => {
        sb.disconnect();
      }, 600000);
    };

    window.addEventListener('focus', onFocus);
    window.addEventListener('blur', onBlur);
    // Specify how to clean up after this effect:
    return () => {
      window.removeEventListener('focus', onFocus);
      window.removeEventListener('blur', onBlur);
      clearTimeout(disconnectTimeOut);
      sb.disconnect();
    };
  }, []);

  const { sendbird, currentUser } = sendbirdData;

  const contextValue = {
    sb: sendbird,
    currentUser,
    activeRoom: '',
    globalMessageEvent: false,
    activeLang: language,
    trans,
  };

  if (currentUser !== null && trans !== null) {
    return (
      <ConnectContext.Provider value={contextValue}>
        <div className="chat-connect-wrapper">
          <ChatConnectList />
          <ChatConnectFooter />
        </div>
      </ConnectContext.Provider>
    );
  }
  return null;
};

Connect.propTypes = {
  sb_id: PropTypes.string.isRequired,
  sb_user: PropTypes.string.isRequired,
  sb_token: PropTypes.string.isRequired,
  language: PropTypes.string.isRequired,
};

export default Connect;
